import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { AddNewOptionItem } from "./AddNewOptionItem";
import { useDispatch, useSelector } from "react-redux";
import {
  clearSelectedOption,
  createNewOption,
} from "../../actions/order-actions/actions";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin, notification } from "antd";
import { DropZoneFile } from "./DropZoneFile";
import { CloseCircleOutlined } from "@ant-design/icons";
import Alert from "../Alert/Alert";

interface Props {
  width: number;
  setOptionSelected: (x: any) => void;
  emptyFields: any;
  setEmptyFields: (x: any) => void;
}

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

export const AddNewOption = ({
  width,
  setOptionSelected,
  emptyFields,
  setEmptyFields,
}: Props) => {
  // all files
  const [files, setFiles] = useState<any>({
    style_file: null,
    fabric_file: null,
    wash_file: null,
    trims_file: null,
    thread_file: null,
  });
  // the selected select input (get the select name)
  const [selectedSelect, setSelectedSelect] = useState<any>(null);
  const [option, setOption] = useState<any>({
    name: "",
    style: "",
    fabric: "",
    wash: "",
    trims: "",
    thread: "",
    qty: "",
    size_qty: "",
    crotch: "",
    delivery_date: "",
  });
  const [alerts, setAlerts] = useState<any>(null);

  const { selectedArticle, updateOptionLoading } = useSelector(
    (state: any) => state.orders
  );
  const dispatch = useDispatch();

  // attach files
  const attachFile = (name: any, file: any) => {
    setFiles({ ...files, [name]: file });
  };

  // Detach file
  const detachFile = (fieldName: any) => {
    setFiles({ ...files, [fieldName]: null });
  };

  // Clear alerts
  useEffect(() => {
    // dispatch(setAlerts(alerts))
    if (alerts) {
      setTimeout(() => {
        setAlerts(null);
      }, 5000);
    }
  }, [alerts]);

  // handle select input value
  const selectHandleChange = (e: any) => {
    setOption({
      ...option,
      [selectedSelect]: selectedSelect === "qty" ? +e : e,
    });
  };

  //   handle input values
  const handleChange = (e: any) => {
    setOption({
      ...option,
      [e.target.name]: e.target.value,
      [e.target.size_qty]: e.target.value,
      [e.target.crotch]: e.target.value,
      [e.target.delivery_date]: e.target.value,
    });
  };

  // get the select name
  const getSelectName = (name: string) => {
    setSelectedSelect(name);
  };
  const ref = useRef(null);

  const [inputList, setInputList] = useState([{ tail: "", qty: "" }]);

  const addInput = () => {
    setInputList([...inputList, { tail: "", qty: "" }]);
  };
  const removeInput = (i: any) => {
    console.log(i);
    const list = [...inputList];
    list.splice(i, 1);
    setInputList([...list]);
  };

  let keys = ["style", "fabric", "wash", "trims", "thread", "qty"];
  let file_keys = [
    "style_file",
    "fabric_file",
    "wash_file",
    "trims_file",
    "thread_file",
  ];
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="order_option_details"
    >
      <div
        className="d-flex align-items-center mb-2 pl-md-3"
        onClick={() => width <= 575 && setOptionSelected(null)}
      >
        {width <= 575 && <FontAwesomeIcon icon={faArrowLeft} />}
        <input
          type="text"
          placeholder="Option name here"
          name="name"
          className="option_details_input option_details_title option_title_input_new ml-1 mb-0 ml-md-0"
          onChange={(e: any) => setOption({ ...option, name: e.target.value })}
          style={{
            border:
              emptyFields && emptyFields.includes("name")
                ? "1px solid #ff00005e"
                : "1px solid #cececea9",
          }}
        />
      </div>

      {keys.map((el: any, i: number) => (
        <div className="row one_option_details" key={i}>
          <div className="col-12">
            <label className="my-2">
              {el === "qty"
                ? "QUANTITY"
                : el === "style"
                ? "STYLE NAME"
                : el.toUpperCase()}
            </label>
          </div>

          <div className="col-12 col-md-7 option_details_select_wrapper">
            {el === "qty" || el === "wash" ? (
              <AddNewOptionItem
                optionKey={el}
                selectHandleChange={selectHandleChange}
                getSelectName={getSelectName}
                option={option}
                emptyFields={emptyFields}
              />
            ) : (
              <input
                type="text"
                onChange={handleChange}
                name={el}
                style={{
                  border:
                    emptyFields && emptyFields.includes(el)
                      ? "1px solid #ff00005e"
                      : "1px solid #cececea9",
                  width: "100%",
                }}
                className={`option_details_input`}
                // style={{
                //   width: "100%",
                // }}
              />
            )}
          </div>
          <div className="col-12 col-md-5 mt-3 mt-md-0">
            {i <= 4 && (
              <DropZoneFile
                setAlerts={setAlerts}
                attachFile={attachFile}
                detachFile={detachFile}
                optionKey={el}
                files={files}
              />
            )}
          </div>
        </div>
      ))}

      {/*  <>
        {inputList.map((el: any, i: number) => (
          <div className="row ">
            <div className="col-4 mt-3">
              {" "}
              <input
                type="text"
                className={`option_details_input`}
                placeholder="size"
              />
            </div>
            <div className="col-4 mt-3">
              {" "}
              <input
                type="text"
                className={`option_details_input`}
                placeholder="qty"
              />
            </div>
            <div className="col-4 mt-3">
              {inputList.length !== 1 && (
                <button
                  onClick={() => removeInput(i)}
                  className="add_new_article_direct_order"
                >
                  remove
                </button>
              )}
            </div>
          </div>
        ))}

        <button
          onClick={addInput}
          className=" option_details_btns  option_save "
        >
          add
        </button>
      </> */}

      <div className="col-7 mt-3 one_option_details">
        <label className="my-2">SIZE 'S QUANTITY</label>
        <input
          type="text"
          className={`option_details_input`}
          onChange={(e: any) =>
            setOption({ ...option, size_qty: e.target.value })
          }
          placeholder="size:qty"
        />
      </div>

      <div className="col-7 mt-3 one_option_details">
        <label className="my-2">Length</label>
        <input
          type="text"
          className={`option_details_input`}
          onChange={(e: any) =>
            setOption({ ...option, crotch: e.target.value })
          }
          placeholder="28"
        />
      </div>
      <div className="col-7 mt-3 one_option_details">
        <label className="my-2">Delivery date</label>
        <input
          type="date"
          className={`option_details_input`}
          onChange={(e: any) =>
            setOption({ ...option, delivery_date: e.target.value })
          }
        />
      </div>
      <div className="option_details_btns my-5 my-md-0 mt-md-5 ">
        <button
          className="option_btn option_save"
          onClick={() => {
            if (
              !option.name ||
              !option.style ||
              !option.fabric ||
              !option.qty
            ) {
              const optionKeys = ["style", "qty", "fabric", "name"].filter(
                (el: any) => option[el] === ""
              );

              setEmptyFields(optionKeys);
              setTimeout(() => {
                setEmptyFields([]);
              }, 4000);
              notification.error({
                placement: "bottomLeft",
                bottom: 50,
                duration: 3,
                message: "",
                description: "Please fill in the required fields",
                className: "danger_notif",
                icon: <CloseCircleOutlined />,
              });
            } else {
              let formData = new FormData();
              // formData.append("details", JSON.stringify(data));
              Object.keys(files)
                .filter((el: any) => files[el])
                .map((el: any) => formData.append(el, files[el]));
              Object.keys(option)
                .filter((el: any) => option[el])
                .map((el: any) => formData.append(el, option[el]));

              formData.append("order_article_id", selectedArticle);
              dispatch(createNewOption(formData));
              // dispatch(clearSelectedOption());
              setEmptyFields([]);
              // setOption({});
            }
          }}
        >
          {updateOptionLoading ? (
            <Spin indicator={antIcon} />
          ) : (
            <>Save Option</>
          )}
        </button>
      </div>
    </motion.div>
  );
};
